<template>
  <skeleton v-if="audio.id === 0" />
  <div v-else
       class="page-audio-detail-container"
  >
    <bottom-bar-layout v-if="loaded"
                       class="page-audio-detail"
                       :show-bar="render.bottomBar.show"
                       :bar-height="barHeight"
                       :target-id="audio.id"
                       target-type="audio"
                       :show-consult="render.showConsult"
                       is-show-share
    >
      <!-- 头部 -->
      <audio-header :audio="audio"
                    :cover="audio.cover"
                    :id="audio.id"
                    type="audio"
                    :title="audio.title"
                    :sub-title="audio.summary"
                    :price="render.primaryPrice"
                    :play-count="audio.playCount"
                    :join-status="audio.joinStatus"
                    :team-size="teamSize"
                    :modal-guide-info="render.modalGuideInfo"
                    :page-guide-info="render.pageGuideInfo"
                    :show-get-point="render.showSharePoint"
                    :gift="render.gift"
                    :collect="render.collect"
                    :hide-collect="hideCollect"
                    @disabledJoin="handleDisabledJoin"
      >
        <group-buy-block-header v-if="groupBuy.activity && !showGroupBuyList"
                                class="group-buy-activity-header"
                                :rule="groupBuy.activity.rule"
                                :start-time="groupBuy.activity.currentTime"
                                :end-time="groupBuy.activity.endTime"
                                :show-countdown="groupBuy.activity.showCountdown"
        />
      </audio-header>

      <member-notice :id="audio.id"
                     type="audio"
                     :qr-code="qrCode"
                     :wechat-group="wechatGroup"
                     :guide-info="guideInfo"
      />
      <!-- 拼团 -->
      <group-buy-block v-if="showGroupBuyList"
                       class="group-buy-block"
                       :id="groupBuy.activity.id"
                       :desc="groupBuy.activity.desc"
                       :rule="groupBuy.activity.rule"
                       :start-time="groupBuy.activity.currentTime"
                       :end-time="groupBuy.activity.endTime"
                       :list="groupBuy.activity.team.list"
                       :max-list-num="groupBuy.activity.team.max"
                       :show-countdown="groupBuy.activity.showCountdown"
      />

      <!-- 相关系列 -->
      <similar-combo-list v-if="combo.length !== 0"
                          :list="combo"
      />

      <!-- 内容 -->
      <recommend-reviews v-if="recommendReviews.length !== 0"
                         :list="recommendReviews"
                         review-type="comment"
                         @click-more="handleRecommendReviewsShowMore"
      />
      <gains-block v-if="showStudentGains"
                   :list="studentGains.list"
                   @click-more="handleStudentGainsShowMore"
      />
      <div class="page-audio-content"
           id="product-detail-content-block"
      >
        <product-content v-model="tabSelected"
                         :nav-bar-list="navBarList"
                         product-type="audio"
                         :product="audio"
                         :programs="programs"
                         :reviews="reviews"
                         :student-gains="studentGains"
        />
      </div>

      <!-- bottom bar -->
      <template #tabbar>
        <bottom-bar :product="product"
                    :audio-id="audio.id"
                    :benefit-bar="render.benefitBar"
                    :trial-programs="trialPrograms"
                    :sell="audio.sell"
                    :render-price="render.bottomBar.renderPrice"
                    :action-bar="render.bottomBar.actionBar"
                    :my-team-id="groupBuy.myTeamId"
                    :page-guide-info="render.pageGuideInfo"
                    :modal-guide-info="render.modalGuideInfo"
                    :collect="render.collect"
                    @disabledJoin="handleDisabledJoin"
        />
      </template>
    </bottom-bar-layout>
    <empty-page v-else
                hint="正在加载数据..."
    />
  </div>

</template>

<script>
  import { mapGetters } from 'vuex';
  import PlayerPlaylistStorageMixin from '@/mixins/player/playerPlaylistStorage';
  import Skeleton from '@/skeleton/AudioDetail';
  import EmptyPage from '@/components/EmptyPage';
  import BottomBarLayout from '@/layout/BottomBarLayout';
  import AudioHeader from '@/components/ProductDetailHeader';
  import GroupBuyBlock from '@/pages/GroupBuy/components/ProductDetailBlock';
  import GroupBuyBlockHeader from '@/pages/GroupBuy/components/ProductDetailBlockHeader';
  import ProductContent from '@/components/ProductDetail/Content';
  import BottomBar from '@/pages/Audio/components/AudioDetailBottomBar';
  import MemberNotice from '@/components/ProductDetailMemberNotice';
  import SimilarComboList from '@/pages/Combo/components/SimilarComboList';
  import RecommendReviews from '@/components/ProductDetailRecommendReviews';
  import GainsBlock from '@/pages/StudentGains/components/ProductDetailBlock';
  import { getAudioDetail } from '@/services/audio';
  import { showCertificatePopup } from '@/services/certificate';
  import { isAppWebView, getUserPlaylistSortStorageName, setToStorage } from '@/utils';
  import { locationToAppWithRoute } from '@/utils/app-route';
  import event from '@/utils/bus';

  export default {
    name: 'PageAudioDetail',
    metaInfo() {
      return {
        title: this.audio.title,
      };
    },
    mixins: [PlayerPlaylistStorageMixin],
    components: {
      Skeleton,
      EmptyPage,
      BottomBarLayout,
      AudioHeader,
      GroupBuyBlock,
      GroupBuyBlockHeader,
      ProductContent,
      BottomBar,
      MemberNotice,
      SimilarComboList,
      RecommendReviews,
      GainsBlock,
    },
    data() {
      return {
        type: 'audio',
        loaded: false,
        audio: {
          id: 0,
          type: '',
          cover: '',
          title: '',
          summary: '',
          playCount: 0,
          joinStatus: '',
          sell: {
            startTime: '',
            status: '',
          },
          update: {
            count: 0,
            status: '',
          },
        },

        trialPrograms: [],

        tabSelected: 'intro',

        programs: {
          start: 0,
          order: 'desc',
          list: [],
        },

        reviews: {
          count: 0,
          start: 0,
          list: [],
        },

        render: {
          showSharePoint: false,
          gift: {
            show: false,
          },
          primaryPrice: {
            current: {
              value: 0,
              name: '',
            },
            origin: {
              value: 0,
              name: '',
            },
            benefit: null,
          },
          benefitBar: {
            show: false,
            desc: '',
            startTime: 0,
            endTime: 0,
          },
          bottomBar: {
            show: false,
            actionBar: {
              type: 'default',
              buttons: [],
            },
            renderPrice: {
              value: 0,
              delete: 0,
              name: '',
            },
          },
          showConsult: false,
          pageGuideInfo: null,
          modalGuideInfo: null,
          navBar: [
            {
              name: '课程介绍',
              type: 'intro',
              show: true,
            },
            {
              name: '课程大纲',
              type: 'program',
              show: true,
            },
            {
              name: '评价',
              type: 'review',
              show: true,
            },
          ],
        },

        combo: [],

        groupBuy: {
          activity: null,
          myTeamId: 0,
        },

        qrCode: null,
        wechatGroup: null,
        guideInfo: null,

        recommendReviews: [],
        studentGains: null,
      };
    },
    computed: {
      ...mapGetters([
        'player',
      ]),
      id() {
        return this.$route.params.id;
      },
      isMember() {
        const { audio } = this;
        const { joinStatus } = audio;
        return joinStatus === 'member' || joinStatus === 'vipMember';
      },
      teamSize() {
        return this.groupBuy.activity ? this.groupBuy.activity.teamSize : 0;
      },
      groupBuyTeamLength() {
        if (!this.groupBuy.activity) return 0;
        return this.groupBuy.activity.team.list.length;
      },
      showGroupBuyList() {
        return this.groupBuyTeamLength > 0;
      },
      navBarList() {
        return this.render.navBar.filter(item => item.show);
      },
      product() {
        return {
          id: this.audio.id,
          price: this.render.primaryPrice.origin.value,
        };
      },
      barHeight() {
        const { render } = this;
        const { benefitBar, pageGuideInfo } = render;
        if (benefitBar && benefitBar.show) return 160;
        if (pageGuideInfo && pageGuideInfo.position === 'bottom') return 166;
        return 120;
      },
      hideCollect() {
        return this.render.bottomBar.show && this.trialPrograms.length === 0;
      },
      showStudentGains() {
        return this.studentGains && this.studentGains.list && this.studentGains.list.length === 2;
      },
    },
    methods: {
      async initPlayer(id, sort) {
        this.setGlobalPlaylistVuex([]);
        const list = await this.fetchRealPlaylist(id, sort, 'audio');
        const playlist = this.isMember ? list : this.trialPrograms;
        this.setGlobalPlayerInfo(playlist, true, false, 'program');
      },
      handleRecommendReviewsShowMore() {
        this.tabSelected = 'review';
        document.getElementById('product-detail-content-block').scrollIntoView({
          block: 'start',
          behavior: 'smooth',
        });
      },
      handleStudentGainsShowMore() {
        this.tabSelected = 'studentGains';
        document.getElementById('product-detail-content-block').scrollIntoView({
          block: 'start',
          behavior: 'smooth',
        });
      },
      async showCertificatePopup(targetType, targetId) {
        await showCertificatePopup(targetType, targetId);
      },
      formatTrialProgramsInfo(trialPrograms, audioTitle) {
        return trialPrograms.map((item) => {
          item.audioTitle = audioTitle;
          return item;
        });
      },
      handleAppWebviewToNative() {
        const route = this.$route;
        locationToAppWithRoute(route, true);
      },
      async fetchData(id) {
        // 获取音频详情
        const data = await getAudioDetail(id);

        // 处理App webview 时Member 跳转原生
        const { audio: { joinStatus } } = data;
        if (isAppWebView() && (joinStatus === 'member' || joinStatus === 'vipMember')) {
          this.handleAppWebviewToNative();
          return;
        }

        this.audio = data.audio;
        this.trialPrograms = this.formatTrialProgramsInfo(
          data.trialPrograms,
          data.audio.title,
        );
        this.reviews = data.reviews;
        this.render = data.render;
        this.combo = data.combo || [];
        this.groupBuy = data.groupBuy;

        this.tabSelected = this.isMember ? 'program' : 'intro';

        this.qrCode = data.qrCode || { title: '', hint: '', src: '' };
        this.wechatGroup = data.wechatGroup;
        this.guideInfo = data.guideInfo;
        this.recommendReviews = data.recommendReviews;
        this.studentGains = data.studentGains;

        this.loaded = true;

        const { id: audioId } = data.audio;
        // 处理音频详情课程大纲
        this.programs = data.programs;
        setToStorage(getUserPlaylistSortStorageName(), data.programs.order);

        this.initPlayer(data.audio.id, data.programs.order);

        // 尝试帮助用户获取音频证书
        this.showCertificatePopup('audio', audioId);
      },
      handleDisabledJoin() {
        this.fetchData(this.id);
      },
    },
    created() {
      this.fetchData(this.$route.params.id);
      event.$once('updateDetail', () => {
        this.fetchData(this.$route.params.id);
      });
    },
    beforeRouteUpdate(to, from, next) {
      this.fetchData(to.params.id);
      next();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-audio-detail {
    &-container {
      min-height: 100%;
      background: @color-white;
    }
  }

  .group-buy-block {
    border-bottom: @size-extra-small solid @background-color-base;
  }

</style>
